import { styled } from 'shared/ui';
import { SESSION_ROOM_COLORS } from '../../../theme/colors';

export const NotesBlock = styled('div', {
  margin: '0 32px 32px',
  padding: '24px',
  borderRadius: '16px',
  backgroundColor: 'rgba(255, 255, 255, 0.06)',
  display: 'grid',
  gap: '16px',
  minWidth: 0,
  overflow: 'hidden',
});

export const NotesRow = styled('div', {
  display: 'grid',
  gap: '8px',
});

export const NotesLabel = styled('div', {
  fontSize: '14px',
  fontWeight: 500,
  color: 'rgba(255, 255, 255, 0.7)',
});

export const NotesText = styled('div', {
  fontSize: '16px',
  lineHeight: 1.5,
  color: SESSION_ROOM_COLORS.white,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
});
